import type { SerializedError } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

export const serverMessageOf = (error: FetchBaseQueryError | SerializedError | undefined): string | undefined => {
  const body = error && 'data' in error ? error.data : undefined;
  return typeof body === 'object' && body !== null && 'message' in body && typeof body.message === 'string'
    ? body.message
    : undefined;
};
